<template>
  <v-form
    v-if="isShown"
    class="filter white mb-5"
    @submit.prevent="submit"
  >
    <v-container fluid>
      <v-row>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('common.name') }}</label>
            <v-text-field
              v-model="localFilter.name"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">ASDB</label>
            <v-text-field
              v-model="localFilter.asdb"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('views.supplier_list.local') }}</label>
            <v-select
              v-model="localFilter.isLocal"
              :items="localOptions"
              clearable
              solo
              hide-details
            />
          </div>
        </v-col>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('views.supplier_item.country') }}
            </label>
            <v-autocomplete
              v-model="localFilter.physicalCountry"
              :loading="loadingCountries"
              :items="countries"
              :search-input.sync="countrySearch"
              item-text="code"
              item-value="id"
              clearable
              :placeholder="$t('common.type_to_search')"
              cache-items
              hide-no-data
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col
          cols="2"
          class="filter__apply"
        >
          <v-btn
            type="submit"
            color="primary"
            outlined
            large
            class="filter__apply-button"
          >
            {{ $t('common.apply') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mongoRegexI } from '@/utils/mongo-regex';

export default {
  name: 'SuppliersFilter',

  model: {
    prop: 'isShown',
  },

  props: {
    isShown: {
      type: Boolean,
      default: false,
    },

    filter: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      localFilter: {
        name: '',
        asdb: '',
        isLocal: null,
        physicalCountry: '',
      },

      localOptions: [
        { value: null, text: '' },
        { value: false, text: this.$t('common.no') },
        { value: true, text: this.$t('common.yes') },
      ],

      countries: [],
      loadingCountries: false,
      countrySearch: '',
    };
  },

  watch: {
    isShown(value) {
      if (value) {
        this.init();
      }
    },

    countrySearch(value) {
      if (value && value !== this.localFilter.physicalCountry) {
        this.getCountries(value);
      }
    },
  },

  methods: {
    init() {
      this.localFilter = { ...this.filter };
    },

    async getCountries(str) {
      this.loadingCountries = true;

      const query = {
        code: mongoRegexI(str),
      };

      try {
        const { data = {} } = await this.$http.get('/countries', {
          params: { query },
        });
        this.countries = data.rows;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loadingCountries = false;
      }
    },

    submit() {
      this.$emit('applyFilter', this.localFilter);
    },
  },
};
</script>
